import { LexerMatcherLibrary } from "../../text/lexer/LexerMatcherLibrary";
import { SourceInfo, SourceRange } from "../../text/lexer/parsing/SourceInfo";
import { BinaryExpression } from "../expressions/BinaryExpression";
import { FunctionExpression } from "../expressions/FunctionExpression";
import { GroupExpression } from "../expressions/GroupExpression";
import { RJExpressionNode } from "../expressions/RJExpressionNode";
import { RJExpressionNodeType } from "../expressions/RJExpressionNodeType";
import { RJToken } from "../expressions/RJToken";
import { RJParserMessages } from "../parsers/RJParserMessages";
import { RJLexer } from "../RJLexer";
import { RJParser } from "../RJParser";
import { Operator } from "./Operator";

export class FunctionOperator extends Operator
{
  constructor( parser:RJParser )
  {
    super( parser );
    this.setStartToken( RJLexer.FunctionMatcher.type, null );    
  }

  processStartNode( nodes:RJExpressionNode[], index:number ):boolean
  {
    if ( index + 1 >= nodes.length )
    {
      return false;
    }

    if ( RJExpressionNodeType.GROUP !== nodes[ index + 1 ].type )
    {
      return false;
    }

    let name = nodes[ index ] as RJToken;
    let group = nodes[ index + 1 ] as GroupExpression;

    let sourceRange = SourceRange.combineNodes( name, group );
    let functionExpression = new FunctionExpression( this._parser, sourceRange );
    functionExpression.setFunctionExpression( name, group );

    RJExpressionNode.replaceRange( nodes, index, 2, functionExpression );


    return true;
  }
}
